import React, { useState, useEffect } from "react";
import { useField, useFormikContext } from "formik";
import { getClosingDateGroup } from "../../../http/api/MasterAPI";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";

const ClosingDateGroupSelect = ({ name, ...props }) => {
  const [listClosingDateGroupSelect, setListClosingDateGroupSelect] = useState(
    []
  );
  const { setFieldValue } = useFormikContext();
  const [field, meta, helpers] = useField(name);

  useEffect(() => {
    GetClosingDateGroupSelect();
  }, []);

  async function GetClosingDateGroupSelect() {
    try {
      const response = await getClosingDateGroup();
      const varList = response.masterVarInfo;
      const result = varList.map((element) => ({
        closingDateGroupSelectCd: element.varCd,
        closingDateGroupSelectContent: element.varValue1,
      }));
      setListClosingDateGroupSelect(result);
    } catch (error) {
      console.error("Failed to fetch sales record types:", error);
    }
  }

  const handleChange = (event) => {
    helpers.setValue(event.target.value);
    if (props.onChange) {
      props.onChange(event);
    }
  };

  return (
    <FormControl {...props} error={meta.touched && Boolean(meta.error)}>
      <InputLabel id={`${name}-label`} shrink>
        {props.label}
      </InputLabel>
      <Select
        labelId={`${name}-label`}
        id={name}
        {...field}
        onChange={handleChange}
        label={props.label}
        value={field.value === null ? -1 : field.value}
        inputRef={props.inputRef}
      >
        <MenuItem value={-1}>未選択</MenuItem>
        {listClosingDateGroupSelect.map((type) => (
          <MenuItem
            key={type.closingDateGroupSelectCd}
            value={type.closingDateGroupSelectCd}
          >
            {type.closingDateGroupSelectContent.replace("99", "月末")}
          </MenuItem>
        ))}
      </Select>
      {meta.touched && meta.error && (
        <FormHelperText>{meta.error}</FormHelperText>
      )}
    </FormControl>
  );
};

export default ClosingDateGroupSelect;
